export enum UserRoles {
  BACKOFFICE = "Backoffice",
  MANAGINGDIRECTOR = "Geschäftsführer",
  BROKER = "Broker",
}

export enum ViewType {
  DATAGRID = "dataGrid",
  CARDGALLERYVIEW = "cardGalleryView",
  GALLERYGRIDVIEW = "galleryGridView",
  CARDGRIDVIEW = "cardGridView",
  GRIDVIEW = "gridView",
  LISTVIEW = "listView",
  CHARTVIEW = "chartView",
}

export enum TabView {
  ACTIVITIES = "Aktivitäten",
  DOCUMENTS = "Dokumente",
  ANGEBOTE = "Onlinevermarktung",
  COMMENTS = "Kommentare",
  HISTORY = "Historie",
  ADDEXISTING = "Vorhandenen hinzufügen",
  ADDNEW = "Neu erstellen",
  AUFGABEN = "Aufgaben",
  OVERVIEW = "Overview",
  DETAILS = "Details",
  MEDIA = "Media",
  FLACHE = "Fläche",
  EMAIL = "E-Mail",
  TEMPLATE = "Template",
  ATTACHEMENTS = "Attachements",
  CRITERIA = "Criteria",
  OFFERS = "Offers",
  PUBLISH = "Publish",
  GENERAL = "Allgemein",
}

export enum contactSearchType {
  PERSONLISTE = "Personliste",
  FIRMENLISTE = "Firmenliste",
}

// Toast Notification Enums
export enum ToastType {
  ERROR = "Error",
  SUCCESS = "Success",
  INFO = "Info",
}
export enum Position {
  TOP = "top",
  BOTTOM = "bottom",
  RIGHT = "right",
  LEFT = "left",
  CENTER = "center",
}
export enum NotificationMessage {
  ValidInsertMessage = "Erfolgreich erstellt",
  ValidUpdateMessage = "Erfolgreich aktualisiert",
  ValidDeleteMessage = "Erfolgreich gelöscht",
  ValidUploadMessage = "Erfolgreich hochgeladen",
  Error = "Bei der Bearbeitung Ihrer Anfrage ist ein Fehler aufgetreten",
  Empty = "Unmöglich, Ihre Anfrage mit leeren Daten zu bearbeiten",
  EmptyComment = "Es ist nicht möglich, einen leeren Kommentar hinzuzufügen",
  NoChanges = "Unmöglich, Ihren Antrag ohne Änderungen zu bearbeiten",
  AddToFavorite = "Objekt als Favorit eingestellt",
  RemovedFromFavorite = "Objekt aus den Favoriten entfernt",
  ValidArchiveMessage = "Erfolgreich archiviert",
}
export enum ToastAnimationShowType {
  FADE = "fade",
  SLIDE = "slide",
}
export enum ObjectType {
  BUILDING = "Gebäude",
  FLOOR = "Etage",
  UNIT = "Unit",
}

export enum ChangeMode {
  Insert = "insert",
  Remove = "remove",
}
export enum BirthdayDetail {
  Today = "Heute",
  Tomorrow = "Morgen",
  NextWeek = "Nächste Woche",
}
export enum WeekDays {
  Mon = "Montag",
  Tue = "Dienstag",
  Wed = "Mittwoch",
  Thu = "Donnerstag",
  Fri = "Freitag",
  Sat = "Samstag",
  Sun = "Sonntag",
}
export enum ROLES {
  MeasureParticipant = "Maßnahmenbeteiligter",
  MeasureManager = "Maßnahmenverantwortlicher",
  SubprojectResponsible = "Teilprojektverantwortlicher",
  SubprojectDeputy = "Teilprojektstellvertreter",
  CoreTeam = "Kernteam",
  SteeringCommittee = "Lenkungsausschuss",
  Admin = "Admin",
  STRATEGIETEM = "Strategieteam",
  SUPER_ADMIN = "Super Admin",
}

export enum ActionType {
  CREATE = "Create",
  SEE = "View",
  UPDATE = "Update",
  DELETE = "Delete",
}
export enum PickListLanguage {
  German = "1031",
  English = "1033",
}
export enum Module {
  companiesList = "Companies",
  dashboard = "Dashboard",
  documents = "Documents",
  gantt = "Gantt",
  measures = "Measure",
  measureDetail = "Measure",
  reports = "Report",
  roleRights = "roleRights",
  subProject = "Subproject",
  subProjectDetail = "Subproject",
  tasks = "Measure-MileStones",
  project = "Project",
  staffMembers = "Staff-Members",
  companies = "ProjectSelection",
  trainingCenter = "Traning-center",
  roles = "Roles",
}

export enum PermissionContext {
  TrainingCenter = "Traning-center",
  Companies = "Companies",
  Subproject = "Subproject",
  ProjectSelection = "ProjectSelection",
  StaffMembers = "Staff-Members",
  RoleRights = "roleRights",
  Project = "Project",
  Milestones = "MileStones",
  Dashboard = "Dashboard",
  Roles = "Roles",
  Gantt = "Gantt",
  Documents = "Documents",

  // Measure  + child context
  Measure = "Measure",
  MeasureTasks = "Measure-Tasks",
  MeasureDescription = "Measure-Description",
  MeasureStatusReport = "Measure-StatusReport",
  MeasureInfos = "Measure-Infos",
  MeasureMileStones = "Measure-MileStones",
  MeasureCreateApprovalRequest = "Measure-CreateApprovalRequest",
  MeasureApprovalRequestStep1 = "Measure-ApprovalRequestStep1",
  MeasureApprovalRequestStep2 = "Measure-ApprovalRequestStep2",
  MeasureChangeHartegrad = "Measure-ChangeHartegrad",
  MeasureRatingUpdate = "Measure-RatingUpdate",
}

export enum PersonStatus {
  ARCHIVED = "NFT",
  ACTIVE = "ANW",
}
